module.exports = __webpack_public_path__ + "img/inserter-2.20ca063c.png";